import {type MoneyResponseBody} from '@online-offer/shared';
import {useFormatCurrency} from 'platform/locale';

import {isNil} from 'ramda';

import {Nullish} from 'shared/web';

/** Whole units unless `decimals` asks for more, e.g. a per-kilometre amount with cents. */
export const formatFinancialProductMoney = (
  money: MoneyResponseBody | Nullish,
  formatCurrency: ReturnType<typeof useFormatCurrency>,
  decimals?: number
) => (isNil(money) ? null : formatCurrency(parseFloat(money.amount), money.currency, decimals));
